// project import
import dashboard from './dashboard';
import pages from './page';
import marketing from './marketing';
import magazzino from './magazzino';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [dashboard, magazzino, marketing, pages]
};

export default menuItems;
